<div
  #containerRef
  class="flex size-[60px] items-center justify-center rounded-full border-2 border-vermillon-500 p-2xs"
>
  <img
    #imageRef
    [ngSrc]="logo().url"
    [width]="60"
    [height]="60"
    [alt]="logo().title || 'logo'"
    class="h-auto max-w-full"
    data-testid="support-portrait"
    crossorigin="anonymous"
  />
</div>
